module.exports = __webpack_public_path__ + "static/4-f01118037d616b379e8c66723f557e8a.jpg";